import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { caseStudies } from '../data/mock';

const CaseStudies = () => {
  const [filter, setFilter] = useState('All');
  
  const filters = ['All', 'AI Tools', 'HFC & CO₂', 'Both'];
  
  const filteredStudies = filter === 'All' 
    ? caseStudies 
    : caseStudies.filter(study => study.serviceType === filter);

  return (
    <div style={{ paddingTop: '80px', background: 'var(--bg-primary)' }}>
      {/* Hero */}
      <section style={{
        padding: '100px 7.6923%',
        background: 'var(--bg-primary)',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <h1 className="display-huge" style={{ marginBottom: '24px' }}>
            Case Studies
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Real-world examples of how we've helped organizations deploy AI and achieve climate goals.
          </p>
        </div>
      </section>

      {/* Filters */}
      <section style={{ padding: '0 7.6923% 60px' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', justifyContent: 'center', gap: '16px', flexWrap: 'wrap' }}>
          {filters.map(f => (
            <button
              key={f}
              onClick={() => setFilter(f)}
              style={{
                background: filter === f ? 'var(--brand-primary)' : 'rgba(255, 255, 255, 0.1)',
                color: filter === f ? '#000000' : 'var(--text-primary)',
                border: 'none',
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: 500,
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
            >
              {f}
            </button>
          ))}
        </div>
      </section>

      {/* Case Studies Grid */}
      <section style={{ padding: '0 7.6923% 100px' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
            gap: '40px'
          }}>
            {filteredStudies.map((study) => (
              <Link
                key={study.id}
                to={`/case-studies/${study.slug}`}
                style={{ textDecoration: 'none' }}
              >
                <div
                  style={{
                    background: 'var(--bg-secondary)',
                    border: '1px solid var(--border-subtle)',
                    overflow: 'hidden',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'all 0.4s ease'
                  }}
                  className="dark-hover"
                >
                  <img
                    src={study.image}
                    alt={study.title}
                    style={{
                      width: '100%',
                      height: '240px',
                      objectFit: 'cover'
                    }}
                  />
                  <div style={{ padding: '32px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <div style={{
                      fontSize: '14px',
                      color: 'var(--brand-primary)',
                      marginBottom: '12px',
                      fontWeight: 500
                    }}>
                      {study.serviceType} • {study.sector}
                    </div>
                    <h3 className="heading-3" style={{ marginBottom: '16px', color: 'var(--text-primary)' }}>
                      {study.title}
                    </h3>
                    <p className="body-small" style={{ marginBottom: '24px', flex: 1 }}>
                      {study.challenge.substring(0, 150)}...
                    </p>
                    <div style={{
                      display: 'flex',
                      gap: '24px',
                      marginBottom: '24px',
                      paddingTop: '16px',
                      borderTop: '1px solid var(--border-subtle)'
                    }}>
                      {Object.entries(study.metrics).slice(0, 2).map(([key, value]) => (
                        <div key={key}>
                          <div style={{ fontSize: '20px', fontWeight: 600, color: 'var(--brand-primary)' }}>
                            {value}
                          </div>
                          <div style={{ fontSize: '13px', color: 'var(--text-muted)', textTransform: 'capitalize' }}>
                            {key.replace(/([A-Z])/g, ' $1').trim()}
                          </div>
                        </div>
                      ))}
                    </div>
                    <div style={{
                      color: 'var(--brand-primary)',
                      fontSize: '16px',
                      fontWeight: 500,
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}>
                      Read full case study <ArrowRight size={18} />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default CaseStudies;
